import keyBy from "lodash/keyBy";
import { IPerson } from "../../../types/persons/person";
import * as types from "../../actions/actionTypes";
import intialState from "../initialState";
import { IPersonState } from "../state";

const loadPersonByIdsStarted = (state, payload) => {
  const persons = {};
  for (let i = 0; i < payload.length; i++) {
    const pId = payload[i];
    persons[pId] = { id: pId, _id: pId, isLoading: true };
  }
  return { ...state, ...persons };
};

// one day I want to refactor this to be:
// {
//     self: "<my id>",
//     all: ["array", "of", "ids"],
//     map: { [key: string]: IPerson }
//     byAssociations: {
//         associationId: ["1", "2", "3"]
//     }
// }

const getStateWithNewPersons = (state: IPersonState, persons: IPerson[]) => {
  const keyedPersons = keyBy(persons, "_id");

  const allPersons = new Set([
    ...Object.keys(keyedPersons),
    ...Object.keys(state.map),
  ]);
  const remappedPersons = Array.from(allPersons).reduce(
    (prev, pid) => ({
      ...prev,
      [pid]: {
        ...(state.map[pid] || {}),
        ...(keyedPersons[pid] || {}),
      },
    }),
    {},
  );

  return {
    ...state,
    map: remappedPersons,
  };
};

const reducer: {
  [key: string]: (state: IPersonState, payload: any) => IPersonState;
} = {
  [types.LOGIN_FULFILLED]: (state: IPersonState, { person }) => ({
    ...getStateWithNewPersons(state, [person]),
    self: person._id,
  }),
  [types.PERSONS_GET_SELF_FULFILLED]: (state, { person }) => ({
    ...getStateWithNewPersons(state, [person]),
    self: person._id,
  }),
  [types.SHIFTS_GET_SHIFT_FULFILLED]: (state, { persons }) =>
    getStateWithNewPersons(state, persons),
  [types.GET_POSTS_FULFILLED]: (state: IPersonState, { persons }) =>
    getStateWithNewPersons(state, persons),
  [types.PERSONS_GET_PERSONS_BY_IDS_FULFILLED]: (state, persons) =>
    getStateWithNewPersons(state, persons),
  [types.PERSONS_GET_FULL_PERSON_BY_ID_FULFILLED]: (state, {person}) =>
    getStateWithNewPersons(state, [person]),
  [types.APPOINTMENTS_GET_ACTIONABLE_FULFILLED]: (
    state: IPersonState,
    { persons },
  ) => getStateWithNewPersons(state, persons),

  [types.PERSONS_GET_PERSONS_BY_IDS_STARTED]: (state, ids) => ({
    ...state,
    ...ids.reduce((m, p) => {
      m[p] = { _id: p, id: p, isLoading: true };
      return m;
    }, {}),
  }),
  // [types.PERSONS_GET_PERSONS_BY_ASSOCIATION_STARTED]: (state, associationId) => {
  //     return { ...state, associations: { ...state.associations }};
  // },
  [types.PERSONS_GET_PERSONS_BY_ASSOCIATION_FULFILLED]: (
    state,
    { associationId, persons },
  ) => {
    const ps = keyBy(persons, "_id");
    return {
      ...state,
      map: {
        ...state.map,
        ...ps,
      },
      byAssociation: {
        ...state.byAssociation,
        [associationId]: Object.keys(ps),
      },
    };
  },
  [types.TOKEN_GET_FULFILLED]: (state, { person }) =>
    getStateWithNewPersons(state, [person]),
  [types.PERSONS_SAVE_PERSON_FULFILLED]: (state, person) =>
    getStateWithNewPersons(state, [person]),
  [types.ACTIVITIES_GET_FULFILLED]: (state, { persons }) =>
    getStateWithNewPersons(state, persons),

  [types.PERSONS_CREATE_PERSON_FULFILLED]: (state, person) =>
    getStateWithNewPersons(state, [person]),

  [types.PERSONS_GET_MANAGEABLE_FULFILLED]: (state, { persons }) => {
    const byId = keyBy(persons, "_id");
    const byAssociation = persons.reduce((prev, person: IPerson) => {
      const associations = Array.from(
        new Set(
          person.associations
            .filter((a) => !a.finish)
            .map((a) => a.associationId),
        ),
      ).reduce(
        (pprev, aid) => ({
          ...pprev,
          [aid]: (prev[aid] || []).concat(aid),
        }),
        {},
      );

      return {
        ...prev,
        ...associations,
      };
    }, {});
    return {
      ...state,
      byAssociation: {
        ...state.byAssociation,
        ...byAssociation,
      },
      map: {
        ...state.map,
        ...byId,
      },
    };
  },
};

export default function personsReducer(state = intialState.persons, action) {
  return action.type in reducer
    ? reducer[action.type](state, action.payload)
    : state;
}
